import { Button } from '@stitch-fix/mode-react';
import { useSelectEvent } from '@stitch-fix/event-reporter';
import classNames from 'classnames';
import styles from './index.module.scss';
interface StickyHeroCtaProps {
  ctaLabel: string;
  ctaHref: string;
  isHidden: boolean;
}
export const StickyHeroCta = ({
  ctaLabel,
  ctaHref,
  isHidden
}: StickyHeroCtaProps) => {
  const {
    reportSelectEvent
  } = useSelectEvent();
  const handleButtonClick = () => {
    if (ctaHref === '/signup') {
      reportSelectEvent({
        action_name: 'navigate_to_signup',
        content_id: 'sticky_cta',
        name: 'take_style_quiz_button',
        schema: 'select'
      });
    }
  };
  return <div className={classNames(styles.stickyCtaContainer, {
    [styles.hidden]: isHidden,
    [styles.shown]: !isHidden
  })}>
      <Button as="a" href={ctaHref} onClick={handleButtonClick} variant="filled-accent-large" width={{
      sm: 'fill'
    }}>
        {ctaLabel}
      </Button>
    </div>;
};